import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _readOnlyError from "@babel/runtime/helpers/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import 'stream-browserify'; // see https://github.com/ericgundrum/pouch-websocket-sync-example/commit/2a4437b013092cc7b2cd84cf1499172c84a963a3
import 'subworkers'; // polyfill for https://bugs.chromium.org/p/chromium/issues/detail?id=31666
import url from 'url';
import ByteBuffer from 'bytebuffer';
import MumbleClient from 'mumble-client';
import WorkerBasedMumbleConnector from './worker-client';
import BufferQueueNode from 'web-audio-buffer-queue';
import mumbleConnect from 'mumble-client-websocket';
import audioContext from 'audio-context';
import ko from 'knockout';
import _dompurify from 'dompurify';
import keyboardjs from 'keyboardjs';
import anchorme from 'anchorme';
import { ContinuousVoiceHandler, PushToTalkVoiceHandler, VADVoiceHandler, initVoice } from './voice';
import { initialize as localizationInitialize, translate } from './loc';
var dompurify = _dompurify(window);

// from: https://gist.github.com/haliphax/5379454
ko.extenders.scrollFollow = function (target, selector) {
  target.subscribe(function (chat) {
    var el = document.querySelector(selector);

    // the scroll bar is all the way down, so we know they want to follow the text
    if (el.scrollTop == el.scrollHeight - el.clientHeight) {
      // have to push our code outside of this thread since the text hasn't updated yet
      setTimeout(function () {
        el.scrollTop = el.scrollHeight - el.clientHeight;
      }, 0);
    } else {
      // send notification
      var last = chat[chat.length - 1];
      if (Notification.permission == 'granted' && last.type != 'chat-message-self') {
        var sender = 'Mumble Server';
        if (last.user && last.user.name) sender = last.user.name();
        new Notification(sender, {
          body: dompurify.sanitize(last.message, {
            ALLOWED_TAGS: []
          })
        });
      }
    }
  });
  return target;
};
function sanitize(html) {
  return dompurify.sanitize(html, {
    ALLOWED_TAGS: ['br', 'b', 'i', 'u', 'a', 'span', 'p', 'img', 'center']
  });
}
var anchormeOptions = {
  // force target _blank attribute
  attributes: {
    target: "_blank"
  },
  // force https protocol except email
  protocol: function protocol(s) {
    if (anchorme.validate.email(s)) {
      return "mailto:";
    } else {
      return "https://";
    }
  }
};
function openContextMenu(event, contextMenu, target) {
  contextMenu.posX(event.clientX);
  contextMenu.posY(event.clientY);
  contextMenu.target(target);
  var closeListener = function closeListener(event) {
    // Always close, no matter where they clicked
    setTimeout(function () {
      // delay to allow click to be actually processed
      contextMenu.target(null);
      unregister();
    });
  };
  var unregister = function unregister() {
    return document.removeEventListener('click', closeListener);
  };
  document.addEventListener('click', closeListener);
  event.stopPropagation();
  event.preventDefault();
}

// GUI

function ContextMenu() {
  var self = this;
  self.posX = ko.observable();
  self.posY = ko.observable();
  self.target = ko.observable();
}
function AddChannelDialog() {
  var self = this;
  self.channelName = ko.observable('');
  self.parentID = 0;
  self.visible = ko.observable(false);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);
  self.addchannel = function () {
    self.hide();
    ui.addchannel(self.channelName());
  };
}
function ConnectDialog() {
  var self = this;
  self.address = ko.observable('');
  self.port = ko.observable('');
  self.tokenToAdd = ko.observable('');
  self.selectedTokens = ko.observableArray([]);
  self.tokens = ko.observableArray([]);
  self.username = ko.observable('');
  self.password = ko.observable('');
  self.channelName = ko.observable('');
  self.joinOnly = ko.observable(false);
  self.visible = ko.observable(true);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);
  self.connect = function () {
    self.hide();
    if (ui.detectWebRTC) {
      ui.webrtc = true;
    }
    ui.connect(self.username(), self.address(), self.port(), self.tokens(), self.password(), self.channelName());
  };
  self.addToken = function () {
    if (self.tokenToAdd() != "" && self.tokens.indexOf(self.tokenToAdd()) < 0) {
      self.tokens.push(self.tokenToAdd());
    }
    self.tokenToAdd("");
  };
  self.removeSelectedTokens = function () {
    this.tokens.removeAll(this.selectedTokens());
    this.selectedTokens([]);
  };
}
function ConnectErrorDialog(connectDialog) {
  var self = this;
  self.type = ko.observable(0);
  self.reason = ko.observable('');
  self.username = connectDialog.username;
  self.password = connectDialog.password;
  self.joinOnly = connectDialog.joinOnly;
  self.visible = ko.observable(false);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);
  self.connect = function () {
    self.hide();
    connectDialog.connect();
  };
}
var ConnectionInfo = /*#__PURE__*/function () {
  function ConnectionInfo(ui) {
    var _this = this;
    _classCallCheck(this, ConnectionInfo);
    this._ui = ui;
    this.visible = ko.observable(false);
    this.serverVersion = ko.observable();
    this.latencyMs = ko.observable(NaN);
    this.latencyDeviation = ko.observable(NaN);
    this.remoteHost = ko.observable();
    this.remotePort = ko.observable();
    this.maxBitrate = ko.observable(NaN);
    this.currentBitrate = ko.observable(NaN);
    this.maxBandwidth = ko.observable(NaN);
    this.currentBandwidth = ko.observable(NaN);
    this.codec = ko.observable();
    this.show = function () {
      if (!ui.thisUser()) return;
      _this.update();
      _this.visible(true);
    };
    this.hide = function () {
      return _this.visible(false);
    };
  }
  return _createClass(ConnectionInfo, [{
    key: "update",
    value: function update() {
      var client = this._ui.client;
      this.serverVersion(client.serverVersion);
      var dataStats = client.dataStats;
      if (dataStats) {
        this.latencyMs(dataStats.mean);
        this.latencyDeviation(Math.sqrt(dataStats.variance));
      }
      this.remoteHost(this._ui.remoteHost());
      this.remotePort(this._ui.remotePort());
      var spp = this._ui.settings.samplesPerPacket;
      var maxBitrate = client.getMaxBitrate(spp, false);
      var maxBandwidth = client.maxBandwidth;
      var actualBitrate = client.getActualBitrate(spp, false);
      var actualBandwidth = MumbleClient.calcEnforcableBandwidth(actualBitrate, spp, false);
      this.maxBitrate(maxBitrate);
      this.currentBitrate(actualBitrate);
      this.maxBandwidth(maxBandwidth);
      this.currentBandwidth(actualBandwidth);
      this.codec('Opus'); // only one supported for sending
    }
  }]);
}();
function CommentDialog() {
  var self = this;
  self.visible = ko.observable(false);
  self.show = function () {
    self.visible(true);
  };
}
var SettingsDialog = /*#__PURE__*/function () {
  function SettingsDialog(settings) {
    var _this2 = this;
    _classCallCheck(this, SettingsDialog);
    this.voiceMode = ko.observable(settings.voiceMode);
    this.pttKey = ko.observable(settings.pttKey);
    this.pttKeyDisplay = ko.observable(settings.pttKey);
    this.vadLevel = ko.observable(settings.vadLevel);
    this.testVadLevel = ko.observable(0);
    this.testVadActive = ko.observable(false);
    this.showAvatars = ko.observable(settings.showAvatars());
    this.userCountInChannelName = ko.observable(settings.userCountInChannelName());
    // Need to wrap this in a pureComputed to make sure it's always numeric
    var audioBitrate = ko.observable(settings.audioBitrate);
    this.audioBitrate = ko.pureComputed({
      read: audioBitrate,
      write: function write(value) {
        return audioBitrate(Number(value));
      }
    });
    this.samplesPerPacket = ko.observable(settings.samplesPerPacket);
    this.msPerPacket = ko.pureComputed({
      read: function read() {
        return _this2.samplesPerPacket() / 48;
      },
      write: function write(value) {
        return _this2.samplesPerPacket(value * 48);
      }
    });
    this._setupTestVad();
    this.vadLevel.subscribe(function () {
      return _this2._setupTestVad();
    });
  }
  return _createClass(SettingsDialog, [{
    key: "_setupTestVad",
    value: function _setupTestVad() {
      var _this3 = this;
      if (this._testVad) {
        this._testVad.end();
      }
      var dummySettings = new Settings({});
      this.applyTo(dummySettings);
      this._testVad = new VADVoiceHandler(null, dummySettings);
      this._testVad.on('started_talking', function () {
        return _this3.testVadActive(true);
      }).on('stopped_talking', function () {
        return _this3.testVadActive(false);
      }).on('level', function (level) {
        return _this3.testVadLevel(level);
      });
      testVoiceHandler = this._testVad;
    }
  }, {
    key: "applyTo",
    value: function applyTo(settings) {
      settings.voiceMode = this.voiceMode();
      settings.pttKey = this.pttKey();
      settings.vadLevel = this.vadLevel();
      settings.showAvatars(this.showAvatars());
      settings.userCountInChannelName(this.userCountInChannelName());
      settings.audioBitrate = this.audioBitrate();
      settings.samplesPerPacket = this.samplesPerPacket();
    }
  }, {
    key: "end",
    value: function end() {
      this._testVad.end();
      testVoiceHandler = null;
    }
  }, {
    key: "recordPttKey",
    value: function recordPttKey() {
      var _this4 = this;
      var combo = [];
      var keydown = function keydown(e) {
        combo = e.pressedKeys;
        var comboStr = combo.join(' + ');
        _this4.pttKeyDisplay('> ' + comboStr + ' <');
      };
      var _keyup = function keyup() {
        keyboardjs.unbind('', keydown, _keyup);
        var comboStr = combo.join(' + ');
        if (comboStr) {
          _this4.pttKey(comboStr).pttKeyDisplay(comboStr);
        } else {
          _this4.pttKeyDisplay(_this4.pttKey());
        }
      };
      keyboardjs.bind('', keydown, _keyup);
      this.pttKeyDisplay('> ? <');
    }
  }, {
    key: "totalBandwidth",
    value: function totalBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), true);
    }
  }, {
    key: "positionBandwidth",
    value: function positionBandwidth() {
      return this.totalBandwidth() - MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), false);
    }
  }, {
    key: "overheadBandwidth",
    value: function overheadBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(0, this.samplesPerPacket(), false);
    }
  }]);
}();
var Settings = /*#__PURE__*/function () {
  function Settings(defaults) {
    _classCallCheck(this, Settings);
    var load = function load(key) {
      return window.localStorage.getItem('mumble.' + key);
    };
    this.voiceMode = load('voiceMode') || defaults.voiceMode;
    this.pttKey = load('pttKey') || defaults.pttKey;
    this.vadLevel = load('vadLevel') || defaults.vadLevel;
    this.toolbarVertical = load('toolbarVertical') || defaults.toolbarVertical;
    this.showAvatars = ko.observable(load('showAvatars') || defaults.showAvatars);
    this.userCountInChannelName = ko.observable(load('userCountInChannelName') || defaults.userCountInChannelName);
    this.audioBitrate = Number(load('audioBitrate')) || defaults.audioBitrate;
    this.samplesPerPacket = Number(load('samplesPerPacket')) || defaults.samplesPerPacket;
  }
  return _createClass(Settings, [{
    key: "save",
    value: function save() {
      var save = function save(key, val) {
        return window.localStorage.setItem('mumble.' + key, val);
      };
      save('voiceMode', this.voiceMode);
      save('pttKey', this.pttKey);
      save('vadLevel', this.vadLevel);
      save('toolbarVertical', this.toolbarVertical);
      save('showAvatars', this.showAvatars());
      save('userCountInChannelName', this.userCountInChannelName());
      save('audioBitrate', this.audioBitrate);
      save('samplesPerPacket', this.samplesPerPacket);
    }
  }]);
}();
var GlobalBindings = /*#__PURE__*/_createClass(function GlobalBindings(config) {
  var _this5 = this;
  _classCallCheck(this, GlobalBindings);
  this.config = config;
  this.settings = new Settings(config.settings);
  this.detectWebRTC = false;
  this.webrtc = false;
  this.fallbackConnector = new WorkerBasedMumbleConnector();
  this.webrtcConnector = {
    connect: mumbleConnect
  };
  this.client = null;
  this.userContextMenu = new ContextMenu();
  this.channelContextMenu = new ContextMenu();
  this.connectDialog = new ConnectDialog();
  this.addChannelDialog = new AddChannelDialog();
  this.connectErrorDialog = new ConnectErrorDialog(this.connectDialog);
  this.connectionInfo = new ConnectionInfo(this);
  this.commentDialog = new CommentDialog();
  this.settingsDialog = ko.observable();
  this.minimalView = ko.observable(false);
  this.log = ko.observableArray();
  this.remoteHost = ko.observable();
  this.remotePort = ko.observable();
  this.thisUser = ko.observable();
  this.root = ko.observable();
  this.avatarView = ko.observable();
  this.messageBox = ko.observable('');
  this.toolbarHorizontal = ko.observable(!this.settings.toolbarVertical);
  this.selected = ko.observable();
  this.selfMute = ko.observable(this.config.defaults.startMute);
  this.selfDeaf = ko.observable(this.config.defaults.startDeaf);
  this.selfMute.subscribe(function (mute) {
    if (voiceHandler) {
      voiceHandler.setMute(mute);
    }
  });
  this.submitOnEnter = function (data, e) {
    if (e.which == 13 && !e.shiftKey) {
      this.submitMessageBox();
      return false;
    }
    return true;
  };
  this.toggleToolbarOrientation = function () {
    _this5.toolbarHorizontal(!_this5.toolbarHorizontal());
    _this5.settings.toolbarVertical = !_this5.toolbarHorizontal();
    _this5.settings.save();
  };
  this.select = function (element) {
    _this5.selected(element);
  };
  this.openSettings = function () {
    _this5.settingsDialog(new SettingsDialog(_this5.settings));
  };
  this.openAddChannel = function (user, channel) {
    _this5.addChannelDialog.parentID = channel.model._id;
    _this5.addChannelDialog.show();
  };
  this.addchannel = function (channelName) {
    var msg = {
      name: 'ChannelState',
      payload: {
        parent: _this5.addChannelDialog.parentID || 0,
        name: channelName
      }
    };
    _this5.client._send(msg);
  };
  this.ChannelRemove = function (user, channel) {
    var msg = {
      name: 'ChannelRemove',
      payload: {
        channel_id: channel.model._id
      }
    };
    _this5.client._send(msg);
  };
  this.applySettings = function () {
    var settingsDialog = _this5.settingsDialog();
    settingsDialog.applyTo(_this5.settings);
    _this5._updateVoiceHandler();
    _this5.settings.save();
    _this5.closeSettings();
  };
  this.closeSettings = function () {
    if (_this5.settingsDialog()) {
      _this5.settingsDialog().end();
    }
    _this5.settingsDialog(null);
  };
  this.getTimeString = function () {
    return '[' + new Date().toLocaleTimeString(navigator.language) + ']';
  };
  this.connect = function (username, host, port) {
    var tokens = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var password = arguments.length > 4 ? arguments[4] : undefined;
    var channelName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
    // if browser support Notification request permission
    if ('Notification' in window) Notification.requestPermission();
    _this5.resetClient();
    _this5.remoteHost(host);
    _this5.remotePort(port);
    log(translate('logentry.connecting'), host);

    // Note: This call needs to be delayed until the user has interacted with
    // the page in some way (which at this point they have), see: https://goo.gl/7K7WLu
    var ctx = audioContext();
    if (!_this5.webrtc) {
      _this5.fallbackConnector.setSampleRate(ctx.sampleRate);
    }
    if (!_this5._delayedMicNode) {
      _this5._micNode = ctx.createMediaStreamSource(_this5._micStream);
      _this5._delayNode = ctx.createDelay();
      _this5._delayNode.delayTime.value = 0.15;
      _this5._delayedMicNode = ctx.createMediaStreamDestination();
    }

    // TODO: token
    (_this5.webrtc ? _this5.webrtcConnector : _this5.fallbackConnector).connect("wss://".concat(host, ":").concat(port), {
      username: username,
      password: password,
      webrtc: _this5.webrtc ? {
        enabled: true,
        required: true,
        mic: _this5._delayedMicNode.stream,
        audioContext: ctx
      } : {
        enabled: false
      },
      tokens: tokens
    }).done(function (client) {
      log(translate('logentry.connected'));
      _this5.client = client;
      // Prepare for connection errors
      client.on('error', function (err) {
        log(translate('logentry.connection_error'), err);
        _this5.resetClient();
      });

      // Make sure we stay open if we're running as Matrix widget
      window.matrixWidget.setAlwaysOnScreen(true);

      // Register all channels, recursively 
      if (channelName.indexOf("/") != 0) {
        channelName = "/" + channelName;
      }
      var _registerChannel = function registerChannel(channel, channelPath) {
        _this5._newChannel(channel);
        if (channelPath === channelName) {
          client.self.setChannel(channel);
        }
        channel.children.forEach(function (ch) {
          return _registerChannel(ch, channelPath + "/" + ch.name);
        });
      };
      _registerChannel(client.root, "");

      // Register all users
      client.users.forEach(function (user) {
        return _this5._newUser(user);
      });

      // Register future channels
      client.on('newChannel', function (channel) {
        return _this5._newChannel(channel);
      });
      // Register future users
      client.on('newUser', function (user) {
        return _this5._newUser(user);
      });

      // Handle messages
      client.on('message', function (sender, message, users, channels, trees) {
        sender = sender || {
          __ui: 'Server'
        };
        ui.log.push({
          type: 'chat-message',
          user: sender.__ui,
          channel: channels.length > 0,
          message: anchorme({
            input: sanitize(message),
            options: anchormeOptions
          })
        });
      });

      // Log permission denied error messages
      client.on('denied', function (type) {
        ui.log.push({
          type: 'generic',
          value: 'Permission denied : ' + type
        });
      });

      // Set own user and root channel
      _this5.thisUser(client.self.__ui);
      _this5.root(client.root.__ui);
      // Upate linked channels
      _this5._updateLinks();
      // Log welcome message
      if (client.welcomeMessage) {
        _this5.log.push({
          type: 'welcome-message',
          message: sanitize(client.welcomeMessage)
        });
      }

      // Startup audio input processing
      _this5._updateVoiceHandler();
      // Tell server our mute/deaf state (if necessary)
      if (_this5.selfDeaf()) {
        _this5.client.setSelfDeaf(true);
      } else if (_this5.selfMute()) {
        _this5.client.setSelfMute(true);
      }
    }, function (err) {
      if (err.$type && err.$type.name === 'Reject') {
        _this5.connectErrorDialog.type(err.type);
        _this5.connectErrorDialog.reason(err.reason);
        _this5.connectErrorDialog.show();
      } else if (err === 'server_does_not_support_webrtc' && _this5.detectWebRTC && _this5.webrtc) {
        log(translate('logentry.connection_fallback_mode'));
        _this5.webrtc = false;
        _this5.connect(username, host, port, tokens, password, channelName);
      } else {
        log(translate('logentry.connection_error'), err);
      }
    });
  };
  this._newUser = function (user) {
    var simpleProperties = {
      uniqueId: 'uid',
      username: 'name',
      mute: 'mute',
      deaf: 'deaf',
      suppress: 'suppress',
      selfMute: 'selfMute',
      selfDeaf: 'selfDeaf',
      texture: 'rawTexture',
      textureHash: 'textureHash',
      comment: 'comment'
    };
    var ui = user.__ui = {
      model: user,
      talking: ko.observable('off'),
      channel: ko.observable()
    };
    ui.texture = ko.pureComputed(function () {
      var raw = ui.rawTexture();
      if (!raw || raw.offset >= raw.limit) return null;
      return 'data:image/*;base64,' + ByteBuffer.wrap(raw).toBase64();
    });
    ui.show_avatar = function () {
      var setting = _this5.settings.showAvatars();
      switch (setting) {
        case 'always':
          break;
        case 'own_channel':
          if (_this5.thisUser().channel() !== ui.channel()) return false;
          break;
        case 'linked_channel':
          if (!ui.channel().linked()) return false;
          break;
        case 'minimal_only':
          if (!_this5.minimalView()) return false;
          if (_this5.thisUser().channel() !== ui.channel()) return false;
          break;
        case 'never':
        default:
          return false;
      }
      if (!ui.texture()) {
        if (ui.textureHash()) {
          // The user has an avatar set but it's of sufficient size to not be
          // included by default, so we need to fetch it explicitly now.
          // mumble-client should make sure we only send one request per hash
          user.requestTexture();
        }
        return false;
      }
      return true;
    };
    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this5.userContextMenu, ui);
    };
    ui.canChangeMute = function () {
      return false; // TODO check for perms and implement
    };
    ui.canChangeDeafen = function () {
      return false; // TODO check for perms and implement
    };
    ui.canChangePrioritySpeaker = function () {
      return false; // TODO check for perms and implement
    };
    ui.canLocalMute = function () {
      return false; // TODO implement local mute
      // return this.thisUser() !== ui
    };
    ui.canIgnoreMessages = function () {
      return false; // TODO implement ignore messages
      // return this.thisUser() !== ui
    };
    ui.canChangeComment = function () {
      return false; // TODO implement changing of comments
      // return this.thisUser() === ui // TODO check for perms
    };
    ui.canChangeAvatar = function () {
      return _this5.thisUser() === ui; // TODO check for perms
    };
    ui.toggleMute = function () {
      if (ui.selfMute()) {
        _this5.requestUnmute(ui);
      } else {
        _this5.requestMute(ui);
      }
    };
    ui.toggleDeaf = function () {
      if (ui.selfDeaf()) {
        _this5.requestUndeaf(ui);
      } else {
        _this5.requestDeaf(ui);
      }
    };
    ui.viewAvatar = function () {
      _this5.avatarView(ui.texture());
    };
    ui.changeAvatar = function () {
      var input = document.createElement('input');
      input.type = 'file';
      input.addEventListener('change', function () {
        var reader = new window.FileReader();
        reader.onload = function () {
          _this5.client.setSelfTexture(reader.result);
        };
        reader.readAsArrayBuffer(input.files[0]);
      });
      input.click();
    };
    ui.removeAvatar = function () {
      user.clearTexture();
    };
    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(user[key[0]]);
    });
    ui.state = ko.pureComputed(userToState, ui);
    if (user.channel) {
      ui.channel(user.channel.__ui);
      ui.channel().users.push(ui);
      ui.channel().users.sort(compareUsers);
    }
    user.on('update', function (actor, properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });
      if (properties.channel !== undefined) {
        if (ui.channel()) {
          ui.channel().users.remove(ui);
        }
        ui.channel(properties.channel.__ui);
        ui.channel().users.push(ui);
        ui.channel().users.sort(compareUsers);
        _this5._updateLinks();
      }
      if (properties.textureHash !== undefined) {
        // Invalidate avatar texture when its hash has changed
        // If the avatar is still visible, this will trigger a fetch of the new one.
        ui.rawTexture(null);
      }
    }).on('remove', function () {
      if (ui.channel()) {
        ui.channel().users.remove(ui);
      }
    }).on('voice', function (stream) {
      console.log("User ".concat(user.username, " started takling"));
      var userNode;
      if (!_this5.webrtc) {
        userNode = new BufferQueueNode({
          audioContext: audioContext()
        });
        userNode.connect(audioContext().destination);
      }
      if (stream.target === 'normal') {
        ui.talking('on');
      } else if (stream.target === 'shout') {
        ui.talking('shout');
      } else if (stream.target === 'whisper') {
        ui.talking('whisper');
      }
      stream.on('data', function (data) {
        if (_this5.webrtc) {
          // mumble-client is in WebRTC mode, no pcm data should arrive this way
        } else {
          userNode.write(data.buffer);
        }
      }).on('end', function () {
        console.log("User ".concat(user.username, " stopped takling"));
        ui.talking('off');
        if (!_this5.webrtc) {
          userNode.end();
        }
      });
    });
  };
  this._newChannel = function (channel) {
    var simpleProperties = {
      position: 'position',
      name: 'name',
      description: 'description'
    };
    var ui = channel.__ui = {
      model: channel,
      expanded: ko.observable(true),
      parent: ko.observable(),
      channels: ko.observableArray(),
      users: ko.observableArray(),
      linked: ko.observable(false)
    };
    ui.userCount = function () {
      return ui.channels().reduce(function (acc, c) {
        return acc + c.userCount();
      }, ui.users().length);
    };
    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this5.channelContextMenu, ui);
    };
    ui.canJoin = function () {
      return true; // TODO check for perms
    };
    ui.canAdd = function () {
      return true; // TODO check for perms
    };
    ui.canEdit = function () {
      return false; // TODO check for perms and implement
    };
    ui.canRemove = function () {
      return true; // TODO check for perms
    };
    ui.canLink = function () {
      return false; // TODO check for perms and implement
    };
    ui.canUnlink = function () {
      return false; // TODO check for perms and implement
    };
    ui.canSendMessage = function () {
      return false; // TODO check for perms and implement
    };
    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(channel[key[0]]);
    });
    if (channel.parent) {
      ui.parent(channel.parent.__ui);
      ui.parent().channels.push(ui);
      ui.parent().channels.sort(compareChannels);
    }
    _this5._updateLinks();
    channel.on('update', function (properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });
      if (properties.parent !== undefined) {
        if (ui.parent()) {
          ui.parent().channel.remove(ui);
        }
        ui.parent(properties.parent.__ui);
        ui.parent().channels.push(ui);
        ui.parent().channels.sort(compareChannels);
      }
      if (properties.links !== undefined) {
        _this5._updateLinks();
      }
    }).on('remove', function () {
      if (ui.parent()) {
        ui.parent().channels.remove(ui);
      }
      _this5._updateLinks();
    });
  };
  this.resetClient = function () {
    if (_this5.client) {
      _this5.client.disconnect();
    }
    _this5.client = null;
    _this5.selected(null).root(null).thisUser(null);
  };
  this.connected = function () {
    return _this5.thisUser() != null;
  };
  this._updateVoiceHandler = function () {
    if (!_this5.client) {
      return;
    }
    if (voiceHandler) {
      voiceHandler.end();
      voiceHandler = null;
    }
    var mode = _this5.settings.voiceMode;
    if (mode === 'cont') {
      voiceHandler = new ContinuousVoiceHandler(_this5.client, _this5.settings);
    } else if (mode === 'ptt') {
      voiceHandler = new PushToTalkVoiceHandler(_this5.client, _this5.settings);
    } else if (mode === 'vad') {
      voiceHandler = new VADVoiceHandler(_this5.client, _this5.settings);
    } else {
      log(translate('logentry.unknown_voice_mode'), mode);
      return;
    }
    voiceHandler.on('started_talking', function () {
      if (_this5.thisUser()) {
        _this5.thisUser().talking('on');
      }
    });
    voiceHandler.on('stopped_talking', function () {
      if (_this5.thisUser()) {
        _this5.thisUser().talking('off');
      }
    });
    if (_this5.selfMute()) {
      voiceHandler.setMute(true);
    }
    _this5._micNode.disconnect();
    _this5._delayNode.disconnect();
    if (mode === 'vad') {
      _this5._micNode.connect(_this5._delayNode);
      _this5._delayNode.connect(_this5._delayedMicNode);
    } else {
      _this5._micNode.connect(_this5._delayedMicNode);
    }
    _this5.client.setAudioQuality(_this5.settings.audioBitrate, _this5.settings.samplesPerPacket);
  };
  this.messageBoxHint = ko.pureComputed(function () {
    if (!_this5.thisUser()) {
      return ''; // Not yet connected
    }
    var target = _this5.selected();
    if (!target) {
      target = _this5.thisUser();
    }
    if (target === _this5.thisUser()) {
      target = target.channel();
    }
    if (target.users) {
      // Channel
      return translate('chat.channel_message_placeholder').replace('%1', target.name());
    } else {
      // User
      return translate('chat.user_message_placeholder').replace('%1', target.name());
    }
  });
  this.submitMessageBox = function () {
    _this5.sendMessage(_this5.selected(), _this5.messageBox());
    _this5.messageBox('');
  };
  this.sendMessage = function (target, message) {
    if (_this5.connected()) {
      // If no target is selected, choose our own user
      if (!target) {
        target = _this5.thisUser();
      }
      // If target is our own user, send to our channel
      if (target === _this5.thisUser()) {
        target = target.channel();
      }
      // Avoid blank message
      if (sanitize(message).trim().length == 0) return;
      // Support multiline
      message = message.replace(/\n\n+/g, "\n\n");
      message = message.replace(/\n/g, "<br>");
      // Send message
      target.model.sendMessage(anchorme(message));
      if (target.users) {
        // Channel
        _this5.log.push({
          type: 'chat-message-self',
          message: anchorme({
            input: sanitize(message),
            options: anchormeOptions
          }),
          channel: target
        });
      } else {
        // User
        _this5.log.push({
          type: 'chat-message-self',
          message: anchorme({
            input: sanitize(message),
            options: anchormeOptions
          }),
          user: target
        });
      }
    }
  };
  this.requestMove = function (user, channel) {
    if (_this5.connected()) {
      user.model.setChannel(channel.model);
      var currentUrl = url.parse(document.location.href, true);
      // delete search param so that query one can be taken into account
      delete currentUrl.search;

      // get full channel path
      if (channel.parent()) {
        // in case this channel is not Root
        var parent = channel.parent();
        currentUrl.query.channelName = channel.name();
        while (parent.parent()) {
          currentUrl.query.channelName = parent.name() + '/' + currentUrl.query.channelName;
          parent = parent.parent();
        }
      } else {
        // there is no channelName as we moved to Root
        delete currentUrl.query.channelName;
      }

      // reflect this change in URL
      window.history.pushState(null, channel.name(), url.format(currentUrl));
    }
  };
  this.requestMute = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(true);
    }
    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfMute(true);
      } else {
        user.model.setMute(true);
      }
    }
  };
  this.requestDeaf = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(true);
      _this5.selfDeaf(true);
    }
    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfDeaf(true);
      } else {
        user.model.setDeaf(true);
      }
    }
  };
  this.requestUnmute = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(false);
      _this5.selfDeaf(false);
    }
    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfMute(false);
      } else {
        user.model.setMute(false);
      }
    }
  };
  this.requestUndeaf = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfDeaf(false);
    }
    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfDeaf(false);
      } else {
        user.model.setDeaf(false);
      }
    }
  };
  this._updateLinks = function () {
    if (!_this5.thisUser()) {
      return;
    }
    var allChannels = getAllChannels(_this5.root(), []);
    var ownChannel = _this5.thisUser().channel().model;
    var allLinked = findLinks(ownChannel, []);
    allChannels.forEach(function (channel) {
      channel.linked(allLinked.indexOf(channel.model) !== -1);
    });
    function findLinks(channel, knownLinks) {
      knownLinks.push(channel);
      channel.links.forEach(function (next) {
        if (next && knownLinks.indexOf(next) === -1) {
          findLinks(next, knownLinks);
        }
      });
      allChannels.map(function (c) {
        return c.model;
      }).forEach(function (next) {
        if (next && knownLinks.indexOf(next) === -1 && next.links.indexOf(channel) !== -1) {
          findLinks(next, knownLinks);
        }
      });
      return knownLinks;
    }
    function getAllChannels(channel, channels) {
      channels.push(channel);
      channel.channels().forEach(function (next) {
        return getAllChannels(next, channels);
      });
      return channels;
    }
  };
  this.openSourceCode = function () {
    var homepage = require('../package.json').homepage;
    window.open(homepage, '_blank').focus();
  };
  this.updateSize = function () {
    _this5.minimalView(window.innerWidth < 320);
    if (_this5.minimalView()) {
      _this5.toolbarHorizontal(window.innerWidth < window.innerHeight);
    } else {
      _this5.toolbarHorizontal(!_this5.settings.toolbarVertical);
    }
  };
});
var ui = new GlobalBindings(window.mumbleWebConfig);

// Used only for debugging
window.mumbleUi = ui;
function initializeUI() {
  var queryParams = url.parse(document.location.href, true).query;
  queryParams = Object.assign({}, window.mumbleWebConfig.defaults, queryParams);
  var useJoinDialog = queryParams.joinDialog;
  if (queryParams.matrix) {
    useJoinDialog = true;
  }
  if (queryParams.address) {
    ui.connectDialog.address(queryParams.address);
  } else {
    useJoinDialog = false;
  }
  if (queryParams.port) {
    ui.connectDialog.port(queryParams.port);
  } else {
    useJoinDialog = false;
  }
  if (queryParams.token) {
    var tokens = queryParams.token;
    if (!Array.isArray(tokens)) {
      tokens = [tokens];
    }
    ui.connectDialog.tokens(tokens);
  }
  if (queryParams.username) {
    ui.connectDialog.username(queryParams.username);
  } else {
    useJoinDialog = false;
  }
  if (queryParams.password) {
    ui.connectDialog.password(queryParams.password);
  }
  if (queryParams.webrtc !== 'auto') {
    ui.detectWebRTC = false;
    if (queryParams.webrtc == 'false' || queryParams.webrtc === false) {
      ui.webrtc = false;
    } else if (queryParams.webrtc == 'true' || queryParams.webrtc === true) {
      ui.webrtc = true;
    }
  }
  if (queryParams.channelName) {
    ui.connectDialog.channelName(queryParams.channelName);
  }
  if (queryParams.avatarurl) {
    // Download the avatar and upload it to the mumble server when connected
    var _url = queryParams.avatarurl;
    console.log('Fetching avatar from', _url);
    var req = new window.XMLHttpRequest();
    req.open('GET', _url, true);
    req.responseType = 'arraybuffer';
    req.onload = function () {
      var upload = function upload(avatar) {
        if (req.response) {
          console.log('Uploading user avatar to server');
          ui.client.setSelfTexture(req.response);
        }
      };
      // On any future connections
      ui.thisUser.subscribe(function (thisUser) {
        if (thisUser) {
          upload();
        }
      });
      // And the current one (if already connected)
      if (ui.thisUser()) {
        upload();
      }
    };
    req.send();
  }
  ui.connectDialog.joinOnly(useJoinDialog);
  ko.applyBindings(ui);
  window.onresize = function () {
    return ui.updateSize();
  };
  ui.updateSize();
}
function log() {
  console.log.apply(console, arguments);
  var args = [];
  for (var i = 0; i < arguments.length; i++) {
    args.push(arguments[i]);
  }
  ui.log.push({
    type: 'generic',
    value: args.join(' ')
  });
}
function compareChannels(c1, c2) {
  if (c1.position() === c2.position()) {
    return c1.name() === c2.name() ? 0 : c1.name() < c2.name() ? -1 : 1;
  }
  return c1.position() - c2.position();
}
function compareUsers(u1, u2) {
  return u1.name() === u2.name() ? 0 : u1.name() < u2.name() ? -1 : 1;
}
function userToState() {
  var flags = [];
  // TODO: Friend
  if (this.uid()) {
    flags.push('Authenticated');
  }
  // TODO: Priority Speaker, Recording
  if (this.mute()) {
    flags.push('Muted (server)');
  }
  if (this.deaf()) {
    flags.push('Deafened (server)');
  }
  // TODO: Local Ignore (Text messages), Local Mute
  if (this.selfMute()) {
    flags.push('Muted (self)');
  }
  if (this.selfDeaf()) {
    flags.push('Deafened (self)');
  }
  return flags.join(', ');
}
var voiceHandler;
var testVoiceHandler;

/**
 * @author svartoyg
 */
function translatePiece(selector, kind, parameters, key) {
  var element = document.querySelector(selector);
  if (element !== null) {
    var translation = translate(key);
    switch (kind) {
      default:
        console.warn('unhandled dom translation kind "' + kind + '"');
        break;
      case 'textcontent':
        element.textContent = translation;
        break;
      case 'attribute':
        element.setAttribute(parameters.name || 'value', translation);
        break;
    }
  } else {
    console.warn("translation selector \"".concat(selector, "\" for \"").concat(key, "\" did not match any element"));
  }
}

/**
 * @author svartoyg
 */
function translateEverything() {
  translatePiece('#connect-dialog_title', 'textcontent', {}, 'connectdialog.title');
  translatePiece('#connect-dialog_input_address', 'textcontent', {}, 'connectdialog.address');
  translatePiece('#connect-dialog_input_port', 'textcontent', {}, 'connectdialog.port');
  translatePiece('#connect-dialog_input_username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('#connect-dialog_input_password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('#connect-dialog_input_tokens', 'textcontent', {}, 'connectdialog.tokens');
  translatePiece('#connect-dialog_controls_remove', 'textcontent', {}, 'connectdialog.remove');
  translatePiece('#connect-dialog_controls_add', 'textcontent', {}, 'connectdialog.add');
  translatePiece('#connect-dialog_controls_cancel', 'attribute', {
    'name': 'value'
  }, 'connectdialog.cancel');
  translatePiece('#connect-dialog_controls_connect', 'attribute', {
    'name': 'value'
  }, 'connectdialog.connect');
  translatePiece('.connect-dialog.error-dialog .dialog-header', 'textcontent', {}, 'connectdialog.error.title');
  translatePiece('.connect-dialog.error-dialog .reason .refused', 'textcontent', {}, 'connectdialog.error.reason.refused');
  translatePiece('.connect-dialog.error-dialog .reason .version', 'textcontent', {}, 'connectdialog.error.reason.version');
  translatePiece('.connect-dialog.error-dialog .reason .username', 'textcontent', {}, 'connectdialog.error.reason.username');
  translatePiece('.connect-dialog.error-dialog .reason .userpassword', 'textcontent', {}, 'connectdialog.error.reason.userpassword');
  translatePiece('.connect-dialog.error-dialog .reason .serverpassword', 'textcontent', {}, 'connectdialog.error.reason.serverpassword');
  translatePiece('.connect-dialog.error-dialog .reason .username-in-use', 'textcontent', {}, 'connectdialog.error.reason.username_in_use');
  translatePiece('.connect-dialog.error-dialog .reason .full', 'textcontent', {}, 'connectdialog.error.reason.full');
  translatePiece('.connect-dialog.error-dialog .reason .clientcert', 'textcontent', {}, 'connectdialog.error.reason.clientcert');
  translatePiece('.connect-dialog.error-dialog .reason .server', 'textcontent', {}, 'connectdialog.error.reason.server');
  translatePiece('.connect-dialog.error-dialog .alternate-username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('.connect-dialog.error-dialog .alternate-password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('.connect-dialog.error-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.retry');
  translatePiece('.connect-dialog.error-dialog .dialog-close', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.cancel');
  translatePiece('.join-dialog .dialog-header', 'textcontent', {}, 'joindialog.title');
  translatePiece('.join-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'joindialog.connect');
  translatePiece('.user-context-menu .mute', 'textcontent', {}, 'usercontextmenu.mute');
  translatePiece('.user-context-menu .deafen', 'textcontent', {}, 'usercontextmenu.deafen');
  translatePiece('.user-context-menu .priority-speaker', 'textcontent', {}, 'usercontextmenu.priority_speaker');
  translatePiece('.user-context-menu .local-mute', 'textcontent', {}, 'usercontextmenu.local_mute');
  translatePiece('.user-context-menu .ignore-messages', 'textcontent', {}, 'usercontextmenu.ignore_messages');
  translatePiece('.user-context-menu .view-comment', 'textcontent', {}, 'usercontextmenu.view_comment');
  translatePiece('.user-context-menu .change-comment', 'textcontent', {}, 'usercontextmenu.change_comment');
  translatePiece('.user-context-menu .reset-comment', 'textcontent', {}, 'usercontextmenu.reset_comment');
  translatePiece('.user-context-menu .view-avatar', 'textcontent', {}, 'usercontextmenu.view_avatar');
  translatePiece('.user-context-menu .change-avatar', 'textcontent', {}, 'usercontextmenu.change_avatar');
  translatePiece('.user-context-menu .reset-avatar', 'textcontent', {}, 'usercontextmenu.reset_avatar');
  translatePiece('.user-context-menu .send-message', 'textcontent', {}, 'usercontextmenu.send_message');
  translatePiece('.user-context-menu .information', 'textcontent', {}, 'usercontextmenu.information');
  translatePiece('.user-context-menu .self-mute', 'textcontent', {}, 'usercontextmenu.self_mute');
  translatePiece('.user-context-menu .self-deafen', 'textcontent', {}, 'usercontextmenu.self_deafen');
  translatePiece('.user-context-menu .add-friend', 'textcontent', {}, 'usercontextmenu.add_friend');
  translatePiece('.user-context-menu .remove-friend', 'textcontent', {}, 'usercontextmenu.remove_friend');
  translatePiece('.channel-context-menu .join', 'textcontent', {}, 'channelcontextmenu.join');
  translatePiece('.channel-context-menu .add', 'textcontent', {}, 'channelcontextmenu.add');
  translatePiece('.channel-context-menu .edit', 'textcontent', {}, 'channelcontextmenu.edit');
  translatePiece('.channel-context-menu .remove', 'textcontent', {}, 'channelcontextmenu.remove');
  translatePiece('.channel-context-menu .link', 'textcontent', {}, 'channelcontextmenu.link');
  translatePiece('.channel-context-menu .unlink', 'textcontent', {}, 'channelcontextmenu.unlink');
  translatePiece('.channel-context-menu .unlink-all', 'textcontent', {}, 'channelcontextmenu.unlink_all');
  translatePiece('.channel-context-menu .copy-mumble-url', 'textcontent', {}, 'channelcontextmenu.copy_mumble_url');
  translatePiece('.channel-context-menu .copy-mumble-web-url', 'textcontent', {}, 'channelcontextmenu.copy_mumble_web_url');
  translatePiece('.channel-context-menu .send-message', 'textcontent', {}, 'channelcontextmenu.send_message');
  translatePiece('.toolbar .tb-horizontal', 'attribute', {
    'name': 'title'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-horizontal', 'attribute', {
    'name': 'alt'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-vertical', 'attribute', {
    'name': 'title'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-vertical', 'attribute', {
    'name': 'alt'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-connect', 'attribute', {
    'name': 'title'
  }, 'toolbar.connect');
  translatePiece('.toolbar .tb-connect', 'attribute', {
    'name': 'alt'
  }, 'toolbar.connect');
  translatePiece('.toolbar .tb-information', 'attribute', {
    'name': 'title'
  }, 'toolbar.information');
  translatePiece('.toolbar .tb-information', 'attribute', {
    'name': 'alt'
  }, 'toolbar.information');
  translatePiece('.toolbar .tb-mute', 'attribute', {
    'name': 'title'
  }, 'toolbar.mute');
  translatePiece('.toolbar .tb-mute', 'attribute', {
    'name': 'alt'
  }, 'toolbar.mute');
  translatePiece('.toolbar .tb-unmute', 'attribute', {
    'name': 'title'
  }, 'toolbar.unmute');
  translatePiece('.toolbar .tb-unmute', 'attribute', {
    'name': 'alt'
  }, 'toolbar.unmute');
  translatePiece('.toolbar .tb-deaf', 'attribute', {
    'name': 'title'
  }, 'toolbar.deaf');
  translatePiece('.toolbar .tb-deaf', 'attribute', {
    'name': 'alt'
  }, 'toolbar.deaf');
  translatePiece('.toolbar .tb-undeaf', 'attribute', {
    'name': 'title'
  }, 'toolbar.undeaf');
  translatePiece('.toolbar .tb-undeaf', 'attribute', {
    'name': 'alt'
  }, 'toolbar.undeaf');
  translatePiece('.toolbar .tb-record', 'attribute', {
    'name': 'title'
  }, 'toolbar.record');
  translatePiece('.toolbar .tb-record', 'attribute', {
    'name': 'alt'
  }, 'toolbar.record');
  translatePiece('.toolbar .tb-comment', 'attribute', {
    'name': 'title'
  }, 'toolbar.comment');
  translatePiece('.toolbar .tb-comment', 'attribute', {
    'name': 'alt'
  }, 'toolbar.comment');
  translatePiece('.toolbar .tb-settings', 'attribute', {
    'name': 'title'
  }, 'toolbar.settings');
  translatePiece('.toolbar .tb-settings', 'attribute', {
    'name': 'alt'
  }, 'toolbar.settings');
  translatePiece('.toolbar .tb-sourcecode', 'attribute', {
    'name': 'title'
  }, 'toolbar.sourcecode');
  translatePiece('.toolbar .tb-sourcecode', 'attribute', {
    'name': 'alt'
  }, 'toolbar.sourcecode');
}
function main() {
  return _main.apply(this, arguments);
}
function _main() {
  _main = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var userMedia, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return localizationInitialize(navigator.language);
        case 1:
          translateEverything();
          _context.prev = 2;
          _context.next = 3;
          return initVoice(function (data) {
            if (testVoiceHandler) {
              testVoiceHandler.write(data);
            }
            if (!ui.client) {
              if (voiceHandler) {
                voiceHandler.end();
              }
              voiceHandler = null;
            } else if (voiceHandler) {
              voiceHandler.write(data);
            }
          });
        case 3:
          userMedia = _context.sent;
          ui._micStream = userMedia;
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          window.alert('Failed to initialize user media\nRefresh page to retry.\n' + _t);
          return _context.abrupt("return");
        case 5:
          initializeUI();
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _main.apply(this, arguments);
}
window.onload = main;